// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Togo from '../_raw/flag/icon_flag_togo.png';

export default () => <img src={Togo} alt="Togo" />;
